interface IDetected {
    hasSideEffects: boolean;
}

class SideEffectDetector {

    public detect<StoreClass>(createStoreMethod: () => any, setterCallback: (store: StoreClass) => void, ignoreFields: string[]): IDetected {
        const store = createStoreMethod();
        const currentUpdatedModel: any = store.getUpdatedModel();
        setterCallback(store);
        const changedUpdatedModel: any = store.getUpdatedModel();

        // delete fields we would like to ignore
        ignoreFields.forEach(field => {
            delete currentUpdatedModel[field];
            delete changedUpdatedModel[field];    
        });
    
        delete currentUpdatedModel._has_changes;
        delete changedUpdatedModel._has_changes;
        
        return {
            hasSideEffects: JSON.stringify(currentUpdatedModel) !== JSON.stringify(changedUpdatedModel),
        }
    }

}

export default SideEffectDetector;